import { UserServiceClient } from 'fitbeat.api-clients';
import { getApiConfig } from '../../config';
import { AuthTokenBuilder } from '../../utils';
import {GoogleAnalytics, GymResolver} from '../../services';
import React, { Component } from 'react';
import { managePushNotificationPermissions, NavigatorService } from '../../utils';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { View, StyleSheet } from 'react-native';
import { getNextBookingStep } from '../actions';
import { ProcessTypes } from 'fitbeat.gym-core';
import { Button, ButtonSize, ButtonTypes, Icon } from '../../components';
import Theme from '../../theme';
import { toggleBookingsModal, WorkoutBookedMessage } from '../../ui';
import { BookingFlowFooter } from '../components';
import { joinWorkout } from '../actions';
import { GymTypes } from 'fitbeat.models';
import { getWorkoutTileData } from '../../SummaryDashboard/actions';

class BookingCompleteStep extends Component {
  static getTitle = () => '';
  static getSubtitle = () => null;

  constructor(props) {
    super(props);

    if (this.isInstantWorkout()) {
      this.done();
    } else {
      managePushNotificationPermissions()
    }
  }

  isInstantWorkout = () => {
    const { workoutSession } = this.props;
    return workoutSession.isInstant
  }

  done = () => {
    const {
      userProfile,
      getNextBookingStep,
      toggleBookingsModal,
      workoutSession,
      workoutSessionService,
      joinWorkout,
      getNextWorkoutForSummaryDashboard,
    } = this.props;
    getNextBookingStep(userProfile, ProcessTypes.Cancel);
    toggleBookingsModal(false);

    const gym = GymResolver.getByName(workoutSession.gymName);
    if (gym.type !== GymTypes.Home || !this.isInstantWorkout()) {
      getNextWorkoutForSummaryDashboard();
      return;
    }

    joinWorkout();
    NavigatorService.navigateContainerTwo('HomeWorkouts', {
      booking: workoutSession,
      userProfile,
      workoutSessionService,
    })
  }

  render() {
    const { t, workoutSession, userProfile } = this.props;
    return (
      <View style={styles.container}>
        <View style={styles.body}>
          <WorkoutBookedMessage
            t={t}
            theme='light'
            workoutSession={workoutSession}
            userProfile={userProfile}
          />
        </View>
          <Button
            title={t('done')}
            fontColor={Theme.PRIMARY}
            buttonType={ButtonTypes.TRANSPARENT}
            onPress={this.done}
            size={ButtonSize.MEDIUM}
          />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
  },
  body: {
    flex: 1,
    justifyContent: 'center',
  },
  title: {
    fontSize: 35,
    textAlign: 'center',
    color: Theme.CHARCOAL,
    fontFamily: Theme.CustomBold,
  },
  date: {
    fontSize: 18,
    paddingBottom: 20,
    color: Theme.GREY_DARK,
    fontFamily: Theme.Custom300,
  },
  footer: {
    paddingVertical: 10
  }
});

const mapStateToProps = (state) => {
  return {
    workoutSession: state.bookings.bookingWizard.workoutSession,
  };
}

const mapDispatchToProps = (dispatch) => {
  const userServiceClient = new UserServiceClient(
    getApiConfig(), fetch, console.log, new AuthTokenBuilder(), GoogleAnalytics);

  return {
    getNextBookingStep: (userProfile, processType) => dispatch(getNextBookingStep(userProfile, processType)),
    toggleBookingsModal: (isVisible) => dispatch(toggleBookingsModal(isVisible)),
    joinWorkout: () => dispatch(joinWorkout()),
    getNextWorkoutForSummaryDashboard: () => dispatch(getWorkoutTileData(userServiceClient, true))
  };
};

BookingCompleteStep = connect(mapStateToProps, mapDispatchToProps)(BookingCompleteStep);
export default translate(['bookings'], { wait: true })(BookingCompleteStep);
